module.exports = __webpack_public_path__ + "static/media/7.a6265de6.jpg";